<template>
<div class="w-100 h-100 p-relative d-flex align-items-center">
  <div class="container">
    <template v-if="isMobile().phone">
      <div class="row no-gutters">
        <div class="col-6" v-for="i in 6" :key="(i+6)" @click="showModal(i+6)">
          <RollImage ref="rollImageMobile" :directoryNo="''+(i+6)" :rotationLv="rotationLv" />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row">
        <div class="col-md-6 col-lg-4" v-for="i in 6" :key="(i+6)" @click="showModal(i+6)">
          <RollImage ref="rollImagePc" :directoryNo="''+(i+6)" :rotationLv="rotationLv" />
        </div>
      </div>
      
    </template>

    <div v-if="!isMobile().phone" class="py-md-4 py-lg-5">
    </div>
    <div v-else class="slider-mobile-spacer">
    </div>

    <div v-if="isMobile().any" class="row justify-content-center">
      <div class="col-8 col-md-6 col-lg-5 col-xl-4 mt-4 mt-md-0">
        <b-form-input v-model="rotationLv" :class="isMobile().any? 'mobile': ''" type="range" min="1" max="8"></b-form-input>
      </div>
    </div>

  </div><!-- /.container -->
  <h2 class="right-title futura tracking-1">ART WORK</h2>
  <div class="right-item">
    <div class="tategaki font-weight-bold">
      紙とセロハンテープでつくられる生き物たち
    </div>
  </div>
  <ArtworkModal ref="artworkModal"/>
  <img class="d-none d-lg-block tissue-bg tissue-bg-1" src="@/assets/images/top/tissue-1v.png">
  <img class="d-none d-lg-block tissue-bg tissue-bg-2" src="@/assets/images/top/tissue-3.png">
  <img class="d-none d-lg-block tissue-bg tissue-bg-3" src="@/assets/images/top/tissue-3.png">
</div>
</template>

<script>
import isMobile from 'ismobilejs'
import { mapActions } from 'vuex'
import RollImage from '@/components/RollImage'
import ArtworkModal from '@/components/ArtworkModal'

export default {
  name: 'ArtWork2',
  components: {
    RollImage, ArtworkModal
  },
  data() {
    return {
      isMobile,
      rotationLv: '1'
    }
  },
  mounted() {
    this.setPageControl({lightTheme: false, left: false, right: false, up: true, down: true})
    for (let i=0; i<6; i++) {
      if(this.$refs.rollImagePc) {
        this.$refs.rollImagePc[i].openingEffect()
      }
      if(this.$refs.rollImageMobile) {
        this.$refs.rollImageMobile[i].openingEffect()
      }
    }
  },
  methods: {
    ...mapActions({
      setPageControl: 'doSetPageControl'
    }),
    showModal(index) {
      this.$refs.artworkModal.show(index)
    }
  }
}

</script>

<style lang="scss" scoped>
.tissue-bg {
  mix-blend-mode: multiply;
  position: absolute;
  opacity: 0.8;
}
.tissue-bg-1 {
  top: calc(100% - 300px);
  right: 0;
  width: 70px;
}
.tissue-bg-2 {
  top: -270px;
  left: -300px;
  width: 600px;
}
.tissue-bg-3 {
  top: calc(100% - 120px);
  left: 300px;
  width: 400px;
}
.slider-mobile-spacer {
  @media (max-aspect-ratio: 10/16) {
    height: 40px;
  }
}
</style>